import {useState} from 'react';
import {SVG} from '../../../../../constants/assetLists';
import {getCorrectPath} from '../../../../../utils';
import AppImageDialog from '../../../../../components/common/AppImageDialog';
import AppTooltip from '../../../../../components/common/AppTooltip';

type Props = {
  file: {
    url: string;
    type: string;
  };
};

function FileBox({file}: Props) {
  const [showImgDialog, setShowImgDialog] = useState(false);

  const fileName = file?.url?.split('/').pop() || '';
  const fileType = file.type;
  const path = getCorrectPath(file.url, file.type);
  let icon = SVG.fileIcon;

  if (fileType.startsWith('image')) {
    icon = SVG.imageIcon;
  } else if (fileType.startsWith('video')) {
    icon = SVG.movieIcon;
  } else if (fileType === 'application/pdf') {
    icon = SVG.pdfIcon;
  } else if (
    fileType === 'application/msword' || // .doc
    fileType ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
  ) {
    icon = SVG.wordIcon;
  } else if (fileType.startsWith('audio')) {
    icon = SVG.micIcon;
  }

  const handleClick = () => {
    if (fileType.startsWith('image')) {
      setShowImgDialog(true);
      return;
    }

    window.open(path, '_blank');
  };

  return (
    <>
      <button
        className="flex items-center gap-2 bg-gray80 px-[5px] py-[3px] rounded-[8px]"
        onClick={handleClick}>
        <div className="w-[18px] h-[18px]">
          <img src={icon} alt="icon" className="w-full h-full object-contain" />
        </div>

        <AppTooltip
          title={
            fileType.startsWith('image') ? (
              <img
                src={path}
                alt="preview"
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 4,
                  objectFit: 'contain',
                }}
              />
            ) : fileName?.length > 20 ? (
              fileName
            ) : (
              ''
            )
          }>
          <span className="underline whitespace-nowrap text-darkBlue cursor-pointer">
            {fileName?.length > 20 ? fileName?.slice(0, 20) + '...' : fileName}
          </span>
        </AppTooltip>
      </button>

      <AppImageDialog
        open={showImgDialog}
        onClose={() => setShowImgDialog(false)}
        imageUrl={path}
      />
    </>
  );
}

export default FileBox;
